import React from 'react'
import Carousel from 'react-multi-carousel'
import 'react-multi-carousel/lib/styles.css'

const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
      slidesToSlide: 1 // optional, default to 1.
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 3,
      slidesToSlide: 1 // optional, default to 1.
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      slidesToSlide: 1 // optional, default to 1.
    }
  };

const sliderImageUrl = [
  //First image url
   //First image url
    {
        src:'https://www.youtube.com/embed/RkY2wNUW0aM', 
    },
    {
        src:'https://www.youtube.com/embed/Kh7zleRIkOE',
        
    },
    {
        src:'https://www.youtube.com/embed/sjbHzd77yZE',
        
    },
    {
        src:'https://www.youtube.com/embed/pKxUasDHAQ0',
        
    },
    {
        src:'https://www.youtube.com/embed/kpz7-oKi4-o',
        
    },
    {
        src:'https://www.youtube.com/embed/YmtHPM_g_3w',
        
    },

    {
        src:'https://www.youtube.com/embed/gG_tqPLwTzg',
        
    },

    {
        src:'https://www.youtube.com/embed/_2cn7_HmPK4',
        
    },
    {
        src:'https://www.youtube.com/embed/-djiSa6gjV4',
        
    },
    {
        src:'https://www.youtube.com/embed/vtXOSURsst0',
        
    },
 
];

const Videoreview = () => {
  return (
       <div class="featuresec ws-section mb-5">
            <div class="container text-center">
              <div className='row'>
                            <div className='col text-center'>
                            <h2 class="ws-section_heading">What Our Students Says!</h2>
                          </div>
                        </div>
        <div className='row g-3'>
            <div className='col-lg-12'>
                <Carousel responsive={responsive} arrows={false} showDots={true} autoPlay={true} infinite={true}
        >
        
            {sliderImageUrl.map((imageUrl, index) => {
                              return (
                                <div className="slider p-1" key={index}>
                                  <iframe
                                width="100%"
                                height="250"
                                src={imageUrl.src} 
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                                title="Embedded youtube"
                                poster="hqdefault"
                              />
                                  <h3>{imageUrl.caption}</h3>
                                </div>
                              );
                            })}
        
        
        </Carousel>
         </div>
          </div>
            </div>
        </div>
  )
}

export default Videoreview